export const DOMAIN_VALIDATION_REGEX = {
  SUBDOMAIN_SHORT: /^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
  SUBDOMAIN_FULL_STR: (topDomain = "") =>
    `^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]\\.${topDomain.replace(/\./g, "\\.")}$`,
  CUSTOM_DOMAIN: /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.[a-z]{2,})+$/,
};
